
import Breadcrumb from '@/components/Breadcrumb'
import TitleBox from '@/components/CSS/TitleBox'
import TitleBox2 from '@/components/CSS/TitleBox2'
import { addQueryParams } from '@/utils'
const qrCodePay = () => import('@/components/qrCodePay')
import { mapGetters } from 'vuex'

export default {
	components: {
		Breadcrumb,
		TitleBox,
		TitleBox2,
		qrCodePay
	},
	data() {
		return {
			parChangeState: true, // 勾选协议
			centerDialogVisible1: false, //取消订单
			centerDialogVisible2: false, // 购买须知
			centerPayDialogVisible: false, // 支付方式
			centerPayQRDialogVisible: false, // 关闭支付提示
			detailsData: null, // 商品信息
			calculateFee: null, //意向金
			compensationList: [], //包赔列表
			compensationListTwo: [], //包赔列表
			compensationFee: '未包赔', //包赔金额
			compensationId: null, //包赔id
			compensationName: null, //包赔名称
			totalPrice: '', //总价
			parInfo: {}, //创建订单回调信息
			articleDetail: null, //购买须知
			orderActive: false,
			compensationVisible: false, // 包赔信息弹窗
			valueAddCompensationIds: [], //增值包赔id合集
			compensationDetail: '', //包赔规则
			compensationAttentionItems: '', // 注意事项
			compensationVisibleData: '' // 包赔弹窗选中数据
		}
	},
	computed: {
		...mapGetters({
			payInfo: 'game/payInfo',
			userAccount: 'user/userAccount'
		}),
		valueAddCompensationIdsPrice() {
			let nuber = 0
			this.valueAddCompensationIds.map(item => {
				nuber += item.compensationFee
			})
			return nuber
		}
	},
	methods: {
		// 购买须知勾选
		parChange() {
			this.parChangeState = !this.parChangeState
		},
		// 检查是否被限制购买商品
		async onCheckLimit() {
			const par = {
				action: {
					userBizLimited: 'PROXY_AGENCY_CREATE_ORDER'
				}
			}
			const check = await this.$api.checkOrderLimit(par)
			if (!check.data) {
				this.$message.error(check.info)
				return false
			}
			return true
		},
		// 意向金提交
		async paymentSubmit() {
			const check = await this.onCheckLimit()
			if (!check) return
			if (this.parChangeState == false) {
				this.$message.error('请阅读并勾选购买须知')
				return
			}
			if (this.$route.query.status == 'null') {
				let _valueAddCompensationIds = null
				if (this.valueAddCompensationIds.length > 0) {
					_valueAddCompensationIds = []
					this.valueAddCompensationIds.map(item => {
						_valueAddCompensationIds.push(item.id)
					})
				}
				// 创建订单
				let data = {
					action: {
						compensationFee: this.compensationFee == '未包赔' ? null : this.compensationFee,
						compensationId: this.compensationId,
						earnestFee: this.calculateFee ? this.calculateFee : 0,
						goodsCompensation: this.compensationFee == '未包赔' ? false : true,
						goodsNo: this.detailsData.goodsNo,
						valueAddCompensationIds: _valueAddCompensationIds
					}
				}
				this.$api.createOrder(data).then(res => {
					if (res.success) {
						// 创建订单成功后续处理
						this.parInfo = {
							...res.data,
							payName: '意向金'
						}
						this.centerPayDialogVisible = true
						this.$nextTick(() => {
							this.$refs['qrPay'].getQrCode(this.parInfo)
							// 当前页面状态变更为待支付
							addQueryParams({ ...this.$route.query, status: 'WAIT_PAY' })

							// 获取订单详情
							let _data = {
								orderNo: res.data.orderNo
							}
							this.$api.orderDetails(_data).then(getRes => {
								if (getRes.success) {
									// 重新对 detailsData 进行赋值
									this.detailsData = getRes.data
									sessionStorage.setItem('orderDtl', JSON.stringify(this.detailsData))
								}
							})
						})
					} else {
						this.$message.error(res.info)
					}
				})
			} else {
				this.$router.push({
					path: '/account/buyerDetails',
					query: { orderNo: this.detailsData.orderNo, parPage: 'true' } //, templateId: this.detailsData.templateId
				})
			}
		},
		closePayModel() {
			this.centerPayDialogVisible = false
		},
		// 获取待支付详情
		getParOrderDtl() {
			let data = {
				orderNo: this.$route.query.orderNo || this.detailsData.orderNo
			}
			this.$api.orderDetails(data).then(res => {
				if (res.success) {
					this.detailsData = res.data
					this.parInfo = {
						...res.data,
						payName: '意向金'
					}
				}
			})
		},
		// 取消订单弹窗
		cancellationOrder() {
			this.centerDialogVisible1 = true
		},
		// 关闭支付方式弹窗
		closePayDialogVisible(done) {
			this.centerPayQRDialogVisible = true
			if (!this.centerPayQRDialogVisible) {
				done()
			}
		},
		// 退出支付方式
		closePayDialogOkVisible() {
			this.centerPayQRDialogVisible = false
			this.centerPayDialogVisible = false
			this.$refs['qrPay'].closeDialogVisible()
			this.$router.push({
				path: '/account/buyerDetails',
				query: { orderNo: this.detailsData.orderNo, parPage: 'true' }
			})
		},
		// 支付成功回调
		paySuccess(payStatus, msg = '支付失败') {
			if (payStatus === 'PAY_SUCCESS') {
				this.$message.success('支付成功！')
				this.$router.push({
					path: '/confirmOrder/paymentCallback',
					query: { orderNo: this.parInfo.orderNo, status: '1' }
				})
			} else {
				this.centerPayDialogVisible = payStatus
				this.$refs['qrPay'].closeDialogVisible()
			}
		},
		// 查询包赔列表
		getCompensationList() {
			let data = {
				action: {
					goodsNo: this.detailsData.goodsNo,
					gameId: this.$route.query.gameId
				}
			}
			this.$api.createOrderCompensationList(data).then(res => {
				if (res.success) {
					if (res.data.length) {
						res.data?.map(item => {
							if (item.type == 'BASIC_COMPENSATION') {
								this.compensationList = this.pushData(item.compensationServiceApiVOList)
								this.compensationFee = this.compensationList[0].compensationFee
								this.compensationId = this.compensationList[0].id
								this.compensationName = this.compensationList[0].name
								this.compensationList[0].isSelected = true
							} else if (item.type == 'VALUE_ADD_COMPENSATION') {
                this.compensationListTwo = this.pushData(item.compensationServiceApiVOList)

                // 如果开启必须选择增值包赔，则默认选中第一个增值包赔
                if (this.compensation.compensationAddNeed) {
                  this.compensationListTwo[0].isSelected = true
                  this.valueAddCompensationIds = [this.compensationListTwo[0]]
                }
							}
						})
					}
				} else {
					this.$message.error(res.info)
				}
			})
		},
		pushData(item) {
			item.map(i => {
				i.isSelected = false
			})
			return item
		},
		// 选中包赔
    clickSelected(val, ind) {
      // 如果开启必须选择基础包赔，则必须选择
      if (this.compensation.compensationBasicNeed && this.compensationId == val.id) {
        // this.$message.error('因追回严重，为了您的账号安全，必须购买包赔')
        return
      }
			this.compensationList.map((item, index) => {
				if (ind == index) {
					val.isSelected = !val.isSelected
					if (val.isSelected) {
						this.totalPrice = this.detailsData.price || this.detailsData.transactionPrice
						this.compensationFee = item.compensationFee
						this.compensationId = item.id
						this.compensationName = item.name
					} else {
						this.totalPrice = this.detailsData.price || this.detailsData.transactionPrice
						this.compensationFee = '未包赔'
						this.compensationId = null
						this.valueAddCompensationIds = []
						this.compensationListTwo.map((twoItem, twoIndex) => {
							twoItem.isSelected = false
						})
					}
				} else {
					item.isSelected = false
				}
			})
		},
		// 多选包赔
		clickCheckbox(val, i) {
      if (this.compensationFee == '未包赔') return this.$message.error('须选择基础包赔后才可加购增值包赔')

      // 如果开启必须选择增值包赔，至少选择一个
      if (this.compensation.compensationAddNeed && this.valueAddCompensationIds.length == 1 && this.valueAddCompensationIds.includes(val)) {
        // this.$message.error('因追回严重，为了您的账号安全，必须购买包赔')
        return
      }

			this.compensationListTwo.map((item, index) => {
				if (i == index) {
					val.isSelected = !val.isSelected
					if (item.isSelected) {
						this.valueAddCompensationIds.push(item)
					}
				}
				if (!item.isSelected) {
					this.valueAddCompensationIds.map((idItem, idIndex) => {
						if (item.id == idItem.id) {
							this.valueAddCompensationIds.splice(idIndex, 1)
						}
					})
				}
			})
		},
		// 查询意向金计算
		getCalculateFee() {
			let data = {
				goodsNo: this.detailsData.goodsNo
			}
			this.$api.createOrderCalculateFee(data).then(res => {
				if (res.success) {
					this.calculateFee = res.data
				} else {
					this.$message.error(res.info)
				}
			})
		},
		// 查看购买须知
		getNotice() {
			let data = {
				action: {
					id: 34,
					title: '意向金购买须知'
				}
			}
			this.$api.articleDetail(data).then(res => {
				if (res.success) {
					this.articleDetail = res.data
					this.centerDialogVisible2 = true
				} else {
					this.$message.error(res.info)
				}
			})
		},
		// 查看包赔说明
		compensationVisibleShow(item, index) {
			this.compensationDetail = item.detail
			this.compensationAttentionItems = item.attentionItems
			this.compensationVisibleData = item
			this.compensationVisible = true
		},
		// 单选包赔弹窗确认
		compensationVisibleCheck() {
			this.compensationList.map(item => {
				if (this.compensationVisibleData.id == item.id) {
					item.isSelected = true
					if (item.isSelected) {
						this.totalPrice = this.detailsData.price || this.detailsData.transactionPrice
						this.compensationFee = item.compensationFee
						this.compensationId = item.id
						this.compensationName = item.name
					} else {
						this.totalPrice = this.detailsData.price || this.detailsData.transactionPrice
						this.compensationFee = '未包赔'
						this.compensationId = null
						this.valueAddCompensationIds = []
						this.compensationListTwo.map((twoItem, twoIndex) => {
							twoItem.isSelected = false
						})
					}
				} else {
					item.isSelected = false
				}
			})
			this.compensationVisible = false
		},
		// 多选包赔弹窗确认
		compensationVisibleCheckTwo() {
			if (this.compensationFee == '未包赔') return this.$message.error('须选择基础包赔后才可加购增值包赔')
			this.compensationListTwo.map(item => {
				if (this.compensationVisibleData.id == item.id) {
					item.isSelected = true
					if (item.isSelected) {
						if (this.valueAddCompensationIds.length <= 0) {
							this.valueAddCompensationIds.push(item)
						} else {
							let _push = false
							this.valueAddCompensationIds.map((idItem, idIndex) => {
								if (idItem.id != item.id) {
									_push = true
								} else {
									_push = false
								}
							})
							if (_push) {
								this.valueAddCompensationIds.push(item)
							}
						}
					}
				}
			})
			this.compensationVisible = false
		}
	},
	mounted() {
		this.detailsData = JSON.parse(sessionStorage.getItem('orderDtl'))
		this.totalPrice = this.detailsData.price || this.detailsData.transactionPrice
		this.getCompensationList()
		this.getCalculateFee()
		if (this.$route.query.status == 'WAIT_PAY') {
			this.getParOrderDtl()
		}
	}
}
